import * as React from "react";
import {useContext} from "react";
import {ConfigContext} from "../../../../context/ConfigContext";
import {CustomerReportDynamicSection, healthyHighlighter, lifecycleStatusDisplay} from "../CustomerReportDynamicSection";
import {AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest} from "../../../../../../generated";
import {MonitoringRecordRequest} from "../../../../../../generated-internal-monitoring/api";
import ServiceTypeEnum = MonitoringRecordRequest.ServiceTypeEnum;
import {customerReport} from "../../../../../style/page_with_sidebar";

export function CustomerReportQueuedEventsErrorStatus({ reFetchReportData }: { reFetchReportData: () => Promise<void> }) {
    const context = useContext(ConfigContext)
    const columns = [{
        id: 'name',
        Header: 'name',
        width: 300,
        accessor: (d: any) => d.name,
    }, {
        id: 'lifecycleStatus',
        Header: 'Lifecycle Status',
        width: 120,
        accessor: (d: any) => lifecycleStatusDisplay(d),
    }, {
        id: 'icon',
        Header: 'error status',
        width: 100,
        accessor: (d: any) =>
            <div>{healthyHighlighter(d.processedEventsWithErrorCount == 0)}</div>,
    }, {
        id: 'processedEventsWithErrorCount',
        Header: 'processed error events',
        width: 170,
        accessor: (d: any) => <div>{d.processedEventsWithErrorCount}</div>,
    }, {
        id: 'oldestErrorEventFrom',
        Header: 'oldest error from',
        width: 240,
        accessor: (d: any) => <div>{d.oldestErrorEventFrom}</div>,
    }, {
        id: 'errorSummary',
        Header: 'error summary',
        width: 200,
        accessor: (d: any) => <div>{d.errorSummary || 'N/A'}</div>,
    }, {
        id: 'responsibleManager',
        Header: 'Responsible manager',
        width: 100,
        accessor: (d: any) => d.responsibleManager,
    }
    ]
    return <CustomerReportDynamicSection
        columns={columns}
        data={customerReport.value?.queuedEventsErrorStatus?.companies}
        currentService={ServiceTypeEnum.QUEUEERRORREPORT}
        reFetchReportData={reFetchReportData}
    />

}
